<template>
	<div v-if="open" class="sms-pricing-modal-overlay" v-on:click.self="$emit('close')">
		<div class="sms-pricing-modal-container">
			<button class="sms-pricing-modal-close" v-on:click="$emit('close')">×</button>
			<div class="sms-pricing-modal-content">
				<h2 class="sms-pricing-modal-title">SMS Pricing</h2>
				<p class="sms-pricing-modal-subtitle">Choose a monthly SMS credit bundle that suits your needs.</p>
				<div class="sms-pricing-table">
					<div class="table-header">
						<div class="header-row">
							<div class="header-cell header-cell--credits">Credits</div>
							<div class="header-cell">Monthly</div>
							<div class="header-cell">Annual (per month)</div>
						</div>
					</div>
					<div class="table-body">
						<div v-for="tier in tiers" :key="tier.credits" class="pricing-row">
							<div class="pricing-cell">
								{{ formatCredits(tier.credits) }}
							</div>
							<div class="pricing-cell">
								{{ formatPrice(tier.monthly) }}
							</div>
							<div class="pricing-cell">
								{{ formatPrice(tier.annual) }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import smsPricingData from "@/data/smsPricing.json";

export default {
	name: "SmsPricingModal",
	props: {
		open: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			tiers: smsPricingData.tiers
		};
	},
	methods: {
		formatCredits(credits) {
			return credits.toLocaleString();
		},
		formatPrice(price) {
			// Format with 2 decimal places if needed
			return `£${price % 1 === 0 ? price : price.toFixed(2)}`;
		},
		disableBodyScroll() {
			document.body.style.overflow = 'hidden';
			document.body.style.position = 'fixed';
			document.body.style.width = '100%';
		},
		enableBodyScroll() {
			document.body.style.overflow = '';
			document.body.style.position = '';
			document.body.style.width = '';
		}
	},
	watch: {
		open(newVal) {
			if (newVal) {
				this.disableBodyScroll();
			} else {
				this.enableBodyScroll();
			}
		}
	},
	mounted() {
		// If modal is open on mount, disable body scroll
		if (this.open) {
			this.disableBodyScroll();
		}
	},
	beforeUnmount() {
		// Ensure body scroll is re-enabled when component is destroyed
		this.enableBodyScroll();
	}
};
</script>


